module.exports = __webpack_public_path__ + "img/proyecto_10_mv.9085b28f.webp";